export * from './i18n.mixin';
export * from './image.mixin';
export * from './moment.mixin';
export * from './numeral.mixin';



// WEBPACK FOOTER //
// ./src/modules/shared/mixins/index.js